'use client';

import useEmblaCarousel from 'embla-carousel-react';
import { PropsWithChildren, useEffect } from 'react';

export default function Slider({ children }: PropsWithChildren) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    loop: true,
    slidesToScroll: 'auto',
  });

  useEffect(() => {
    if (emblaApi) {
      ('Embla initialized');
    }
  }, [emblaApi]);

  return (
    <section className='embla'>
      <div className='embla__viewport' ref={emblaRef}>
        <div className='embla__container'>{children}</div>
      </div>
    </section>
  );
}
